import { render, staticRenderFns } from "./OptionsItemCell.vue?vue&type=template&id=4015d23e&scoped=true&"
import script from "./OptionsItemCell.vue?vue&type=script&lang=js&"
export * from "./OptionsItemCell.vue?vue&type=script&lang=js&"
import style0 from "./OptionsItemCell.vue?vue&type=style&index=0&id=4015d23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4015d23e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardSubtitle,VImg})
